import React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

const Footer = () => {
    return (
        <Box color="gray" fontSize="12px" style={{ textAlign: 'center' }}>
            By logging in, you agree to the{' '}
            <Link href="https://www.foreflight.com/support/eula/" color="#4a90e2" underline="hover">
                Terms of Use
            </Link>{' '}
            and{' '}
            <Link
                href="https://www.foreflight.com/about/privacy/"
                color="#4a90e2"
                underline="hover"
            >
                Privacy Policy
            </Link>
            .
        </Box>
    );
};
export default Footer;
